var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import { appMessage, toggleModal } from '../../Actions';
import T from '../../Locale';
const valueSaving = () => ({ type: 'VALUES_SAVING' });
export const valueEdit = (item) => ({
    type: 'VALUES_EDIT',
    item
});
const valueSaved = (item) => ({
    type: 'VALUES_SAVED',
    item
});
const valuesReceived = (items) => ({
    type: 'VALUES_RECEIVED',
    items
});
const valuesDeleting = (id) => ({
    type: 'VALUES_DELETING',
    itemId: id
});
const valuesNotDeleted = (id) => ({
    type: 'VALUES_NOT_DELETED',
    itemId: id
});
const valuesDeleted = (id) => ({
    type: 'VALUES_DELETED',
    itemId: id
});
export const valuesToggleForShare = (id) => ({
    type: 'VALUES_TOGGLE_FOR_SHARE',
    itemId: id
});
export const resetValuesForSharing = () => ({ type: 'VALUES_RESET_SHARE' });
/**
 * When loading Value items, the additional data will be a JSON string.
 * This converts the additional JSON strings into objects.
 *
 * @param {object} item
 * @return {object}
 */
export const convertAdditionalData = (item) => {
    // Create a new object identical to the item.
    const newItem = Object.assign({}, item);
    if (item.additional) {
        // Create a new additional container on the newItem.
        newItem.additional = {};
        Object.keys(item.additional).forEach((key) => {
            const data = item.additional[key];
            if (typeof data === 'string') {
                newItem.additional[key] = JSON.parse(data);
            }
            else {
                newItem.additional[key] = data;
            }
        });
    }
    return newItem;
};
/**
 * Action for sharing values.
 *
 * @param {string} email
 *   The email of the user to share values with.
 * @param {array} values
 *   If specific values should be shared, this is an array of ids.
 *   If all values should be shared, this array is empty.
 */
export function shareValues(email, values = []) {
    return () => __awaiter(this, void 0, void 0, function* () {
        try {
            // Build the form data to send.
            const data = new FormData();
            data.append('receiver', email);
            if (values.length) {
                data.append('values', values);
            }
            const response = yield axios.post('/values/share', data);
            return response.status;
        }
        catch (error) {
            return error.response.status;
        }
    });
}
export function deleteValue(id) {
    return (dispatch) => __awaiter(this, void 0, void 0, function* () {
        dispatch(valuesDeleting(id));
        try {
            yield axios.delete(`/value/${id}`);
            dispatch(valuesDeleted(id));
            dispatch(toggleModal());
        }
        catch (error) {
            dispatch(appMessage(T.translate('values.deleteError')));
            dispatch(valuesNotDeleted(id));
            dispatch(toggleModal());
        }
    });
}
export function saveValue(item, image = false, files = []) {
    return (dispatch) => __awaiter(this, void 0, void 0, function* () {
        dispatch(valueSaving());
        const url = item.id ? `/value/${item.id}` : '/values/save';
        const data = new FormData();
        data.append('type', item.type);
        data.append('name', item.name);
        data.append('value', item.value);
        if (image) {
            data.append('image', image);
        }
        else if (item.image) {
            data.append('image', item.image);
        }
        files.forEach((file, index) => {
            data.append(`file${index}`, file);
        });
        if (item.additional) {
            Object.keys(item.additional).forEach((key) => {
                data.append(key, JSON.stringify(item.additional[key]));
            });
        }
        if (item.files) {
            data.append('files', JSON.stringify(item.files));
        }
        try {
            const response = yield axios.post(url, data, { headers: { 'Content-Type': 'multipart/form-data' } });
            const savedValue = response.data;
            if (savedValue) {
                const savedItem = convertAdditionalData(savedValue);
                const message = item.id ? T.translate('values.edited') : T.translate('values.created');
                dispatch(valueSaved(savedItem));
                dispatch(appMessage(message, 'status'));
            }
            else {
                dispatch(appMessage(T.translate('misc.error')));
            }
        }
        catch (error) {
            dispatch(appMessage(T.translate('misc.error')));
        }
    });
}
export function getValues() {
    return (dispatch) => __awaiter(this, void 0, void 0, function* () {
        const response = yield axios.get('/values/get');
        const items = response.data.map((item) => convertAdditionalData(item));
        dispatch(valuesReceived(items));
    });
}
